export class PossibleAnswer {
    id: number;
    questionId: number;
    no: number;
    description: string;
    isCorrectAnswer: Boolean;
    posibleAnswerType: string;
}
